import { ModelDef } from '../../CORE/src/common/$models/ModelDef'

/**
 * 見積:家具移動オプション質問マスタ
 */
export const yhc_kazai_kaguido_destination_questions: ModelDef = {
  tableName: 'yhc_kazai_kaguido_destination_questions',
  tableLabel: '見積:家具移動オプション質問マスタ',
  primaryKeyColType: 'NUMBER',
  replicable: true,
  defaultSort: { key: 'sort', order: 'asc' },
  columns: {
    adminName: {
      type: 'STRING',
      label: '管理用名称',
      replicable: true,
    },
    questionTitle: {
      type: 'STRING',
      label: '質問タイトル',
      replicable: true,
      inputHelpText:
        '家財追加後に表示される移動タイトルです。短い単語にすることを推奨します。',
    },
    questionText: {
      type: 'STRING',
      label: '質問',
      replicable: true,
      validate: { notEmpty: true },
      width: { xs: 24 },
    },
    sort: {
      type: 'NUMBER',
      label: '選択順序',
      replicable: true,
      validate: { notEmpty: true },
    },
    description: {
      type: 'TEXT',
      label: '説明文',
      replicable: true,
      width: { xs: 24 },
    },
    parentQuestion: {
      type: 'RELATIONSHIP_MANY_TO_ONE',
      label: '親質問',
      replicable: true,
      relationshipManyToOne: {
        collectionName: 'yhc_kazai_kaguido_destination_questions',
        labelFormatter: (row) => row.adminName,
      },
    },
    dependentOptions: {
      type: 'ARRAY_OF_OBJECT',
      label: '依存する選択肢s',
      replicable: true,
      width: { xs: 48 },
      defaultValue: () => [],
      columns: {
        dependentOption: {
          type: 'RELATIONSHIP_MANY_TO_ONE',
          label: '依存する選択肢',
          relationshipManyToOne: {
            collectionName: 'yhc_kazai_kaguido_destination_options_and_prices',
            labelFormatter: (row) =>
              `${row.question?.questionText}:${row.optionText}`,
          },
        },
      },
    },
    enabledFrom: {
      type: 'DATETIME',
      label: '有効期間 開始',
      replicable: true,
      validate: { notEmpty: true },
    },
    disabledAt: {
      type: 'DATETIME',
      label: '有効期間 終了',
      replicable: true,
      validate: { notEmpty: true },
    },
  },
}
